import { initMonitoring } from '@/lib/monitoring'
import { createRoot } from 'react-dom/client'
import './index.css'
import '../styles.css'
import App from './App.tsx'

initMonitoring()

createRoot(document.getElementById('root')!).render(<App />)
